<app-loading *ngIf="loading"></app-loading>
<div class="panel-header panel-header-sm">
    <div class="row link-header ml-5">
        <div>
            <a class="a-home" routerLink="/home">Home/</a>
        </div>
        <div>
            <a class="text-info" routerLink="/company-type">Planes</a>
        </div>
    </div>
</div>

<div class="main-content">

    <!-- INPUT COMPANY -->
    <div class="row justify-content-center">
        <div class="col-md-12">
            <form #formulario="ngForm">
                <div class="card">
                    <div class="card-header ">
                        <div class="row">
                            <div class="col-10">
                                <b class="card-title" *ngIf="!isEdit">Nuevo Plan</b>
                                <b class="card-title text-warning" *ngIf="isEdit">Modificar Plan</b>
                            </div>
                            <div class="col-2 float-right" *ngIf="isEdit"> 
                                <a class="btn btn-danger btn-icon btn-round "
                                    (click)="cleanModel()"><i class="fas fa-times"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-6">
                                <label>
                                    Nombre <span class="text-danger" *ngIf="validate_msg(1, 'planName')"> *campo obligatorio!</span>
                                </label>
                                <div class="form-group">
                                    <input type="text" class="form-control" name="planName" [(ngModel)]="plan.planName" required/>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <label>
                                    Precio <span class="text-danger" *ngIf="validate_msg(2, 'planPrice')"> *valor no aceptado!</span>
                                </label>
                                <div class="form-group">
                                    <input type="number" class="form-control" name="planPrice" [(ngModel)]="plan.planPrice" (change)="validate_number(1, 'planPrice')" min=0 required/>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <label>
                                    Descuento <span class="text-danger" *ngIf="validate_msg(2, 'planDiscount')"> *valor no aceptado!</span>
                                </label>
                                <div class="form-group">
                                    <input type="number" class="form-control" name="planDiscount" [(ngModel)]="plan.planDiscount" (change)="validate_number(2, 'planDiscount', 'planPrice')" min=0 required/>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <label></label>
                                <div class="form-group">
                                    <button class="btn btn-info btn-round btn-erp" (click)="save()" *ngIf="!isEdit"
                                        [disabled]="isDisabled || formulario.invalid">Guardar</button>
                                    <button class="btn btn-primary btn-block btn-erp" (click)="update()" *ngIf="isEdit"
                                        [disabled]="isDisabled || formulario.invalid">Actualizar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
    <!-- END INPUT COMPANY -->

    <!-- TABLE -->
    <div class="row justify-content-center">
        <div class="col-md-12">
            <div class="card">
                <div class="card-header">
                    <h4 class="card-title">Listado de planes</h4>
                    <h6 class="category">Puedes filtrar por cualquier campo en la caja de texto "Search
                        records"</h6>
                </div>
                <div class="card-body">
                    <div class="dataTables_wrapper">
                        <div class="row">
                            <div class="col-sm-12 col-md-6">
                                <div class="dataTables_length" id="datatable_length">
                                    <label>
                                        Show
                                        <select name="datatable_length" aria-controls="datatable"
                                            class="form-control form-control-sm" (change)="entriesChange($event)">
                                            <option value="10" [selected]="entries==10">10</option>
                                            <option value="25" [selected]="entries==25">25</option>
                                            <option value="50" [selected]="entries==50">50</option>
                                            <option value="-1" [selected]="entries==-1">All</option>
                                        </select>
                                        entries
                                    </label>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6">
                                <div id="datatable_filter" class="dataTables_filter">
                                    <label>
                                        <input type="search" class="form-control form-control-sm"
                                            placeholder="Search records" aria-controls="datatable"
                                            (keyup)="filterTable($event)" />
                                    </label>
                                </div>
                            </div>
                        </div>
                        <ngx-datatable class="bootstrap selection-cell" [columnMode]="'force'" [headerHeight]="50"
                            [footerHeight]="50" [rowHeight]="'auto'" [limit]="entries != -1 ? entries:undefined"
                            [rows]="temp" (activate)="onActivate($event)">
                            <ngx-datatable-column name="Nombre" prop="planName"></ngx-datatable-column>
                            <ngx-datatable-column name="Precio" prop="planPrice"></ngx-datatable-column>
                            <ngx-datatable-column name="Descuento" prop="planDiscount"></ngx-datatable-column>
                            <ngx-datatable-column [sortable]="false" [canAutoResize]="false" [draggable]="false"
                                [resizeable]="false">
                                <ng-template ngx-datatable-header-template let-value="value"
                                    let-allRowsSelected="allRowsSelected" let-selectFn="selectFn">
                                    Acciones
                                </ng-template>
                                <ng-template ngx-datatable-cell-template let-value="value" let-isSelected="isSelected"
                                    let-onCheckboxChangeFn="onCheckboxChangeFn">
                                    <a href="#" class="btn btn-round btn-success btn-icon btn-sm edit"
                                        (click)="editFunction($event)" ngbTooltip="Editar"><i
                                            class="fas fa-pencil-alt"></i>
                                    </a>
                                    <a href="#" class="btn btn-round btn-danger btn-icon btn-sm remove"
                                        (click)="deleteFunction($event)" ngbTooltip="Eliminar"><i
                                            class="fas fa-times"></i>
                                    </a>
                                </ng-template>
                            </ngx-datatable-column>
                        </ngx-datatable>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- END TABLE -->
</div>